import React from 'react';
import { Link } from 'react-router-dom';

const ComplaintsPolicy = () => (
  <>
    <h2>NiteFlirt COMPLAINTS POLICY</h2>

    <p>
      <strong>
        By directing your browser to this website, you accept and agree to this Complaints Policy, which forms part of the NiteFlirt User Agreement. Please read it carefully.
      </strong>
      &nbsp;All definitions used in the Terms of Service apply to this Complaints Policy.
    </p>

    <ul>
      <li>
        To make a copyright infringement complaint, or to submit a DMCA Takedown request, please follow the procedure set forth in our Terms of Service,&nbsp;
        <Link to="/help/tos#DMCA">HERE</Link>
        .
      </li>
      <li>
        To appeal a Content moderation or removal decision, please follow the procedure set forth in our Terms of Service,&nbsp;
        <Link to="/help/tos#DMCA">HERE</Link>
        .
      </li>
      <li>
        To submit a billing or charge-related complaint, please follow the procedure set forth in our Terms of Service,&nbsp;
        <Link to="/help/tos#billing">HERE</Link>
        .
      </li>
      <li>
        If you identify any images, real or simulated, depicting minors engaged in sexual activity within any Content, or any other form of illegal pornography or acts, please report the material to us immediately by either emailing us at&nbsp;
        <a href="mailto:playfair@niteflirt.com">playfair@niteflirt.com</a>
          &nbsp;or by filling out our&nbsp;
        <a href="https://support.niteflirt.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer">Support Form</a>
          &nbsp;(select “Play Fair Inquiry”). Include with your report any appropriate evidence, including the name of the Flirt/Member, URL, and date and time of identification. All reports will immediately be investigated and the appropriate action will be taken.
      </li>
    </ul>

    <p>
      For all other complaints, please follow the procedure below:
    </p>

    <p>
      To report a complaint regarding the Site, any user, Member or Flirt, send an email detailing your complaint to&nbsp;
      <a href="mailto:support@niteflirt.com">support@niteflirt.com</a>
      . We will review and resolve your complaint within seven (7) business days. In appropriate circumstances, we will take immediate action in order to help resolve the problem. You agree that in attempting to resolve any complaint you send to us we may, in our sole and exclusive determination, share your complaint in part or in whole with other individuals involved and/or otherwise implicated in the complaint.
    </p>

    <p>
      Reporting bad behavior. If you identify a Flirt or Member you believe to be violating any of the Terms of Service or NiteFlirt Rules, please immediately let us know by emailing&nbsp;
      <a href="mailto:support@niteflirt.com">support@niteflirt.com</a>
      . All reports are reviewed as soon as practicable but in no event more than seven (7) business days. If the bad behavior involves violation of any law or conduct that is defrauding, threatening or endangering anyone, please fill out our&nbsp;
      <a href="https://support.niteflirt.com/hc/en-us/requests/new" target="_blank" rel="noopener noreferrer">Support Form</a>
      &nbsp;(select “Play Fair Inquiry”). All reports are reviewed as quickly as possible, but if you suspect someone may be in immediate danger, please contact your local authorities also.
    </p>

    <p>
      In making a complaint, you must provide enough information so we can investigate your complaint, such as name of Member or Flirt, date and time of identification and any relevant URLs. If a complaint is missing important information, we may not be able to properly consider it.
    </p>

    <p>
      With respect to all other matters, we only provide a service which connects you with third-party content. The Site is for entertainment purposes only, and the Site and any Flirt Services obtained through the Site are provided “AS IS”. Therefore, we enforce only those rules we feel are necessary to comply with law, community standards, and for the safety of our users, Members and Flirts.
    </p>

    <p>
      Abuse of this complaints process: We do not tolerate complaints made in bad faith or complaints that are abusive, harassing, or otherwise intended to harm us, or any user, Member, Flirt or third party. If you are a Member and make an abusive or unfounded complaint, we reserve the right to suspend or terminate your Member account and/or refuse to provide access to the Site or Flirt Services with or without reason or notice to you.
    </p>

  </>
);

export default ComplaintsPolicy;
